import { render, staticRenderFns } from "./FundHistory.vue?vue&type=template&id=10f081a1&"
import script from "./FundHistory.vue?vue&type=script&lang=js&"
export * from "./FundHistory.vue?vue&type=script&lang=js&"
import style0 from "./FundHistory.vue?vue&type=style&index=0&id=10f081a1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports